var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p0 text-center"},[_c('div',{ref:"dropdown",staticClass:"more dropdown"},[_c('div',{staticClass:"dropdown__button-wrapper",on:{"click":_vm.toggleDropdown}},[_vm._t("button")],2),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right burger-dropdown",class:_vm.dropdownClass},[_vm._t("list-elements")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }